module.exports = __webpack_public_path__ + "img/fatemeh-haghnejad-explorers.4a4e5e7.jpeg";